// Lightweight logger that is silent in production builds.
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
};

export default logger;
